import {
    ALL_CUSTOM_BATCHES,
    VIEW_CUSTOM_BATCH,
    POST_CUSTOM_BATCH,
} from "../constant/ActionType";

export default function AllCustomBatchReducers(
    state = {
        allcustomBatch: [],
        viewcustomBatch: [],
        postedBatch: [],
    },
    action
) {
    switch (action.type) {
        case ALL_CUSTOM_BATCHES:
            return {
                ...state,
                allcustomBatch: action?.data,
            };
        case VIEW_CUSTOM_BATCH:
            return {
                ...state,
                viewcustomBatch: action?.data?.data,
            };
        case POST_CUSTOM_BATCH:
            return {
                ...state,
                postedBatch: action?.data?.data,
            };
        default:
    }

    return state;
}
